
import Vue from "vue";
import { opponents, Opponent } from "./data";
import ReadyGo, { ReadyGoState } from "./components/ReadyGo.vue";
import Finish from "./components/FinishView.vue";
import Character, { CharacterState } from "./components/CharacterView.vue";

const states = [
  "initial",
  "ready",
  "contest",
  "victory",
  "defeat",
  "finish",
] as const;
type State = typeof states[number];

export default Vue.extend({
  name: "App",
  data() {
    return {
      state: "initial" as State,
      result: "",
      readyGo: "none" as ReadyGoState,
      keyready: true,
      currentStage: -1,
      timer: {
        begin: 0,
        opponentHandle: 0,
      },
    };
  },
  computed: {
    showStart(): boolean {
      return ["initial", "defeat"].includes(this.state);
    },
    showNext(): boolean {
      return this.state === "victory";
    },
    showReturnTitle(): boolean {
      return this.state === "finish";
    },
    showResult(): boolean {
      return ["victory", "defeat"].includes(this.state);
    },
    showMessage(): boolean {
      return this.state === "finish";
    },
    hasNextStage(): boolean {
      return opponents.length > this.currentStage + 1;
    },
    showStrike(): boolean {
      return ["ready", "contest"].includes(this.state);
    },
    shakesView(): boolean {
      return this.state === "defeat";
    },
    currentOpponent(): Opponent {
      return opponents[this.currentStage];
    },
    characterState(): CharacterState {
      switch (this.state) {
        case "ready":
        case "contest":
          return "init";
        case "victory":
          return "left-win";
        case "defeat":
          return "right-win";
        default:
          return "none";
      }
    },
  },
  methods: {
    next: function () {
      (this.$refs.keyBindInput as HTMLElement).focus();
      if (this.state === "defeat") {
        this.currentStage = -1;
        this.state = "initial";
        this.readyGo = "none";
      } else if (this.state === "finish") {
        this.currentStage = -1;
        this.state = "initial";
        this.readyGo = "none";
      } else if (this.hasNextStage) {
        this.currentStage++;
        this.state = "ready";
        this.readyGo = "ready";
        const delayMs = Math.random() * 5000 + 2000;
        const go = () => {
          this.state = "contest";
          this.readyGo = "go";
          this.timer.begin = new Date().getTime();
          this.timer.opponentHandle = setTimeout(() => {
            this.stricken();
          }, this.currentOpponent.time);
        };
        setTimeout(go, delayMs);
      } else {
        this.state = "finish";
      }
    },
    strike: function () {
      if (this.state === "contest") {
        this.state = "victory";
        const score = new Date().getTime() - this.timer.begin;
        clearTimeout(this.timer.opponentHandle);
        this.result = `WIN: ${score} ms`;
      }
    },
    stricken: function () {
      if (this.state === "contest") {
        this.state = "defeat";
        const score = new Date().getTime() - this.timer.begin;
        this.result = `LOSE: ${score} ms`;
      }
    },
    keydown: function () {
      if (this.keyready) {
        this.keyready = false;
        this.strike();
      }
    },
    keyup: function () {
      this.keyready = true;
    },
  },
  components: {
    ReadyGo,
    Finish,
    Character,
  },
});
